import React, { Component } from 'react';

import { web3FromAddress } from '@polkadot/extension-dapp';
import { decodeAddress, encodeAddress } from '@polkadot/keyring';
import { ApiPromise, WsProvider } from '@polkadot/api';
import { stringToHex, hexToU8a, isHex } from '@polkadot/util';
import { Animated } from 'react-animated-css';
import { getBlockchainLag } from './GetBlockchainLag';
import axios from 'axios';
import ProgressionPopup from './ProgressionPopup';

// Form to send a RMRK NFT to another account
class RmrkSendNftForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nftId: '',
      recipient: '',
      nftsOptions: <option value="" key="loading">Loading...</option>,
      submitDisabled: false,
      errorMessage: '',
      progressMessage: '',
      modalOpened: false,
      allowModalClose: false,
      redirectToGallery: false,
      error: {
        nftId: false,
        recipient: false
      }
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.closePopup = this.closePopup.bind(this);
    this.checkIfNFTsAreSynced = this.checkIfNFTsAreSynced.bind(this);
  }

  closePopup() {
    if (this.state.redirectToGallery) {
      this.props.changeVisibilities({ collectionGallery: true, sendNft: false })
    }
    this.setState({
      modalOpened: false,
      allowModalClose: false,
      redirectToGallery: false
    })
  }

  resetForm() {
    this.setState({
      nftId: '',
      recipient: ''
    });
  }

  handleInputChange(event) {
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  handleSubmit(event) {
    if (this.validateForm()) this.sendRmrkNft();
    event.preventDefault();
  }

  isValidAddressPolkadotAddress(address) {
    try { encodeAddress(isHex(address) ? hexToU8a(address) : decodeAddress(address)); return true; }
    catch (error) { return false; }
  }

  validateForm() {
    var message = '';
    var errors = {
      nftId: false,
      recipient: false
    }

    // Collection name must not be empty
    if (this.state.nftId.length == 0) {
      errors.nftId = true;
      message += 'NFT ID must be filled. '
    } else { this.setState({ error: { nftId: false } }); }

    // Symbol must not be empty
    if (!this.isValidAddressPolkadotAddress(this.state.recipient)) {
      errors.recipient = true;
      message += 'Recipient address is not valid. '
    }

    if (message != '') {
      this.setState({ error: errors, errorMessage: message, progressMessage: '' });
      return false;
    } else {
      this.setState({ error: errors, errorMessage: '' });
      return true;
    }
  }

  async sendRmrkNft() {

    // Breaks if no account
    if (this.props.accountAddress == '') { alert("No account found, please install Polkadot.js extension"); return; }

    // Disables submit
    this.setState({ submitDisabled: true, modalOpened: true });

    try {

      // Craft send RMRK
      var progressMessage = "Step 1 - Send NFT - Generating RMRK for send";
      this.setState({ progressMessage: progressMessage });

      const nftId = this.state.nftId;
      const recipientAddress = this.state.recipient;
      const rmrk = "RMRK::SEND::1.0.0::" + nftId + "::" + recipientAddress;

      // Debug logs
      console.info("Generated RMRK for NFT: " + rmrk);

      // Check blockchain lag
      var blockchainLag = await getBlockchainLag();
      if (blockchainLag > process.env.REACT_APP_BLOCKCHAIN_LAG_LIMIT) {
        throw ('Blockchain lag is too heavy (> ' + process.env.REACT_APP_BLOCKCHAIN_LAG_LIMIT + ' blocks), aborting process');
      }

      // If lag is okay, check if NFT is still in user's balance
      var nftIdSplit = nftId.split('-');
      var collectionId = nftIdSplit[1] + '-' + nftIdSplit[2];
      var contractId = nftIdSplit[0] + '-' + nftIdSplit[1] + '-' + nftIdSplit[2] + '-' + nftIdSplit[3];
      var tokenSn = nftIdSplit[4];
      var nftStillInUserBalance = await axios.get(process.env.REACT_APP_API_URL + "api/v1/balances/" + this.props.accountAddress)
        .then(function (response) {
          var collections = response.data.data.collections;

          // Checks for NFT presence in balance of recipient
          for (var indexCollection in collections) {
            if (collections[indexCollection].id == collectionId) {
              for (var indexOrb in collections[indexCollection].orbs) {
                if (collections[indexCollection].orbs[indexOrb].contract == contractId
                  && collections[indexCollection].orbs[indexOrb].token.sn == tokenSn) { // Check for this NFT's SN in this collection
                  return true;
                }
              }
            }
          }
          // If NFT not detected in balance, return false
          return false;
        })
        .catch(function (error) {
          return false;
        });

      if (!nftStillInUserBalance) {
        throw ('NFT was not in user\'s balance after final check');
      }

      // Get API and injector from extension
      const wsProvider = new WsProvider(process.env.REACT_APP_WSPROVIDER_URL);
      const api = await ApiPromise.create({ provider: wsProvider });
      const injector = await web3FromAddress(this.props.accountAddress);

      // Generating extrinsic
      const remarkExtrinsic = api.tx.system.remark(stringToHex(rmrk));

      progressMessage = "Step 2 - Send NFT - Requesting signature for send RMRK";
      this.setState({ progressMessage: progressMessage });

      await remarkExtrinsic.signAndSend(this.props.accountAddress, { signer: injector.signer }, async ({ status }) => {
        if (status.isBroadcast) {
          this.resetForm();
          progressMessage = "Step 3 - Send NFT - Broadcasted transaction, waiting for inclusion";
          this.setState({ progressMessage: progressMessage });
        } else if (status.isInBlock) {

          console.info(`Completed at block hash #${status.asInBlock.toString()}`);
          progressMessage = "Step 4 - Send NFT - Transaction included in block, waiting for blockchain sync...";
          this.setState({ progressMessage: progressMessage });

          // Checks if collections are synced
          this.checkIfNFTsAreSynced(nftId, recipientAddress, () => {
            this.props.updateSelectsFromAPI();
            progressMessage = "Step SUCCESS - Send NFT - NFT successfully sent";
            this.setState({ progressMessage: progressMessage });
            this.setState({ submitDisabled: false, allowModalClose: true, redirectToGallery: true });
          }, (error) => {
            progressMessage = "Step PARTIAL (NO BLOCKCHAIN SYNC) - Send NFT - " + error;
            this.setState({ progressMessage: progressMessage });
            this.setState({ submitDisabled: false, allowModalClose: true, redirectToGallery: true });
          });

        } else {
          console.info(`Current status: ${status.type}`);
        }
      }).catch((error) => {
        throw ('Error during transaction: ', error);
      });

    } catch (error) {

      // Enables submit
      this.setState({ submitDisabled: false, allowModalClose: true });

      // Logs error
      console.warn("Exception: " + error);
      progressMessage = "Step ERROR - Send NFT - Process aborted: " + error;
      this.setState({ progressMessage: progressMessage });

    }

  }

  // Routine to check if NFTs are synced
  checkIfNFTsAreSynced(nftId, recipientAddress, callback, error) {

    var nftIdSplit = nftId.split('-');
    var collectionId = nftIdSplit[1] + '-' + nftIdSplit[2];
    var contractId = nftIdSplit[0] + '-' + nftIdSplit[1] + '-' + nftIdSplit[2] + '-' + nftIdSplit[3];
    var tokenSn = nftIdSplit[4];

    var callsPerformedToCheckSync = 0;
    var nftSyncInterval = setInterval(nftSyncCheck, process.env.REACT_APP_CHECK_SYNC_TIMER_MS);

    async function nftSyncCheck() {
      console.info("Check for NFT sync #" + ++callsPerformedToCheckSync);

      await axios.get(process.env.REACT_APP_API_URL + "api/v1/balances/" + recipientAddress)
        .then(function (response) {
          var collections = response.data.data.collections;

          // Checks for NFT presence in balance of recipient
          for (var indexCollection in collections) {
            for (var indexOrb in collections[indexCollection].orbs) {
              if (collections[indexCollection].orbs[indexOrb].contract == contractId
                && collections[indexCollection].orbs[indexOrb].token.sn == tokenSn) { // Check for this NFT's SN in this collection
                clearInterval(nftSyncInterval);
                callback();
                return true;
              }
            }
          }

          // Throw exception is number of polls exceeded
          if (callsPerformedToCheckSync >= process.env.REACT_APP_CHECK_SYNC_NB_RETRIES) {
            clearInterval(nftSyncInterval);
            error("NFT is not synced (timeout) but was successfully sent to blockchain, please try to reload page later");
          }
          return false;
        });
    }

  }

  render() {
    return (
      <Animated animationIn="fadeIn" animationInDuration={300} isVisible={this.props.display}>
        <div className={`card ${!this.props.display ? ' d-none' : ''}`}>

          <div className="page-heading page-heading--overlay" style={{ backgroundImage: "url(" + this.state.nftImageUrl + ")", backgroundColor: "rgba(0, 0, 0, 0.6)" }}>
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="alc-staff-inner post__meta-block post__meta-block--top posts__item--card posts__item">
                    <div className="posts__category">
                      <span className="label posts__cat-label posts__cat-label--category-1">{this.state.nftCollectionId}</span>
                      <span className="label posts__cat-label posts__cat-label--kusama">{process.env.REACT_APP_CHAIN_NAME}</span>
                      <span className="label posts__cat-label posts__cat-label--category-1">RMRK</span>
                    </div>
                    <header className="alc-staff__header">
                      <h1 className="page-heading__title">
                        Send NFT
                        <span className="alc-staff__header-last-name">
                          {this.state.nftName}
                        </span>
                      </h1>
                      <span className="alc-staff__header-role">
                        <h5 className="alc-staff__header-role-item ">
                          NFT ID / {this.state.nftId}
                        </h5>
                      </span>
                    </header>
                    <button className="btn btn-primary" onClick={() => this.props.changeVisibilities({ nftGallery: true, sendNft: false })}>Back to NFTs</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <form onSubmit={this.handleSubmit}>
            <div className="card__content row">
              <div className="col-12 alert alert-warning" hidden={this.state.errorMessage == ''}>{this.state.errorMessage}</div>
              <div className={`col-12 form-group${this.state.error.recipient ? ' has-error' : ''}`}>
                <label>Send to {process.env.REACT_APP_CHAIN_NAME} address:</label>
                <input className="form-control" type="text" name="recipient" value={this.state.recipient} onChange={this.handleInputChange} placeholder="e.g. 5EUbjEyHGDMggiuNUYwPznmRmemLuPrY5do3kv7PbhYmexwc" />
              </div>
              <div className="col-12 form-group">
                <input className="btn btn-ksmgallery" type="submit" disabled={this.state.submitDisabled} value="Send this NFT" />
              </div>
            </div>
          </form>
        </div>

        <ProgressionPopup
          popupTitle="Sending NFT..."
          modalOpened={this.state.modalOpened}
          allowModalClose={this.state.allowModalClose}
          progressMessage={this.state.progressMessage}
          closePopup={this.closePopup}
        />

      </Animated>
    )
  }
}

export default RmrkSendNftForm;